export const PortOfEntryInput = [
    {name:'KATTUPALLI PORT/INDIA',value:1},{name : 'CHENNAI PORT/INDIA ',value:2},{name : 'ENNORE PORT/INDIA',value:3},{name : 'KRISHNAPATNAM PORT/INDIA',value:4},{name : 'TUTICORIN PORT',value:5},{name : 'VISAKHAPATNAM PORT',value:6},{name : 'PARADIP PORT',value:7},{name : 'HALDIA PORT',value:8},{name : 'CHENNAI AIRPORT/INDIA ',value:9}
]
  

export const PortOfEntryCodes=[
    {
        name:'INKAT1',value:1
    },
    {
        name:'INMAA6',value:2
    },
    {
        name:'INENR',value:3
    },
    {
        name:'INKRI1',value:4
    },
    {
        name:'INTUT',value:5
    },
    {
        name:'INVTZ',value:6
    },
    {
        name:'INPRT',value:7
    },
    {
        name:'INCUU',value:8
    },
    {
        name:'MAA',value:9
    },
]